import { Box, HStack, VStack } from '@chakra-ui/react';
import { useTranslation } from 'react-i18next';

import { Text } from 'components/uikit';
import { ArrowRightIcon } from 'components/uikit/icons';
import { DOMAIN } from 'data/constants';

interface VndTgQrErrorBannerProps {
  hasDeeplink?: boolean;
  isMobile?: boolean;
  fromBank?: string | null;
  errorImage?: string;
  // Overrides the default description (e.g. bank-specific retry button)
  descriptionKey?: string;
}

export const VndTgQrErrorBanner = ({
  hasDeeplink = false,
  isMobile = false,
  fromBank = null,
  errorImage = `https://payment.${DOMAIN}/assets/vnd/errorImage.png`,
  descriptionKey: descriptionKeyOverride,
}: VndTgQrErrorBannerProps) => {
  const { t } = useTranslation('payments');

  const descriptionKey =
    descriptionKeyOverride ??
    (hasDeeplink && isMobile
      ? 'vnd_tg_qr_error_description_mobile_deeplink'
      : isMobile
      ? 'vnd_tg_qr_error_description_mobile'
      : 'vnd_tg_qr_error_description');

  const description = t(descriptionKey, {
    defaultValue: t('vnd_tg_qr_error_description'),
  });

  if (isMobile) {
    return (
      <VStack spacing='16px' alignItems='center' w='100%'>
        <Text
          fontWeight='400'
          fontSize='md'
          color='grey.primaryText'
          lineHeight='1.4'
          textAlign='center'
        >
          {t('vnd_tg_qr_error_title')}
        </Text>

        <Box
          as='img'
          src={errorImage}
          alt='Error illustration'
          w='150px'
          h='auto'
          flexShrink={0}
        />

        <Text
          fontWeight='400'
          fontSize='md'
          color='grey.primaryText'
          lineHeight='1.4'
          textAlign='center'
        >
          {description}
        </Text>
      </VStack>
    );
  }

  return (
    <HStack justifyContent='space-between' spacing='16px' w='100%'>
      <VStack spacing='8px' alignItems='start' flex='1'>
        <Text
          fontWeight='400'
          fontSize='md'
          color='grey.primaryText'
          lineHeight='1.4'
          flex='1'
        >
          {t('vnd_tg_qr_error_title')}
        </Text>
        <HStack w='100%' gap='8px'>
          <Text
            fontWeight='400'
            fontSize='md'
            color='grey.primaryText'
            lineHeight='1.4'
          >
            {description}
          </Text>
          <ArrowRightIcon
            color='grey.primaryText'
            boxSize='26px'
            flexShrink={0}
          />
        </HStack>
      </VStack>

      <Box
        as='img'
        src={errorImage}
        alt='Error illustration'
        w={fromBank === 'ВТБ' ? '180px' : '170px'}
        h='auto'
        borderRadius={fromBank === 'Альфа-Банк' ? '15px' : '10px'}
      />
    </HStack>
  );
};
